module.exports = __webpack_public_path__ + "img/passport-dont.9954d34c.png";